export default {"src":"/_next/static/media/collaboration.fcbb614d.svg","height":1200,"width":1600};